<template lang="html">
  <!-- Logo removed - AVA logo is now in the top navigation bar -->
  <div></div>
</template>
<script>
  export default {
		methods: {
			onLogoClick() {
        this.$emit('logoClick');
      },
		},
	};
</script>
<style lang="scss"></style>
